






























































































import { Utils } from '@/helper/utils';
import { Component } from 'vue-property-decorator';
import { Base } from './base';
import { IPaymentDialog } from '@/models/paymentDialog';
import { depositLogService } from '@/shared';

@Component({
    props: [
        'options', 'loggedInUserEmailProp', 'loggedInUserIdProp'
    ],

})
export default class PaymentDialog extends Base {

    public loading: boolean = false;
    public paymentDialog: boolean = false;
    public options: IPaymentDialog;
    public paymentUrl: string = "";
    public urlFeildId: string = "";
    public customerKey: string = "";
    public vin: string = "";
    public amount: string = "";
    public totalAmount: string = "";
    public invoiceNumber: string = "";
    public tenantFieldId: string = "";
    public currentTenantId: number = 0;
    public enterpriseFieldId: string = "";
    public currentEnterpriseId: number = 0;
    public storeFieldId: string = "";
    public currentStoreId: number = 0;
    public userSessionId: string = "";
    public dealId: string = "";
    public storeName: string = "";
    public currentStoreName: string = "";
    public address: string = "";
    public zipcode: string = "";
    public city: string = "";
    public state: string = "";
    public phoneNumber: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public comments: string = "";
    public transactionHeaderId: string = "";
    public lastPaymentDetailId: string = "";
    public loggedInUserId: string = "";
    public loggedInUserEmail: string = "";
    public customerEmail: string = "";
    public merchantEmail: string = "";
    public recordKey: string = "";
    public recordIdentifier: string = "";
    public type: string = "";
    public squareDialog: string = "";
    public showTextField: string = "";
    public other: string = "";
    public selectedCharges: string = "";
    public name: string = "";
    public account: string = "";
    public control: string = "";
    public reference: string = "";
    public description: string = "";
    public lineItems: string = "";
    public isAmountOverride: string = "";
    public isDeductiblePayment: string = "";
    public isSendPaymentReceipt: string = "";
    public amountWithServiceCharges: string = "";
    public isOverrideCCFeeApplied: string = "";
    public bypassReason: string = "";
    public adHocLineitem: string = "";
    public ArPayments: string = "";
    public title: string = "";
    public isPaymentProviderConfigured: boolean = false;
    public isPaymentProviderValidated: boolean = false;
    public skeletonLoading: boolean = false;
    public paymentProviderStatusMessage: string = "";

    public async mounted() {
        this.$root.$on('validatePaymentProvider', () => {
            this.validatePaymentProviderDetails();
        });

        this.userSessionId = localStorage.getItem('sessionId') ?? "";

        if (!this.currentTenantId && this.options.tenantId) {
            this.currentTenantId = this.options.tenantId;
        }
        if (!this.currentEnterpriseId && this.options.enterpriseId) {
            this.currentEnterpriseId = this.options.enterpriseId;
        } if (!this.currentStoreId && this.options.storeId) {
            this.currentStoreId = this.options.storeId;
        }
        if (this.$props.loggedInUserEmailProp) {
            this.loggedInUserEmail = this.$props.loggedInUserEmailProp;
        }

        if (this.$props.loggedInUserIdProp) {
            this.loggedInUserId = this.$props.loggedInUserIdProp;
        }

        await this.getPaymentProviderDetails();

    }

    public async getPaymentProviderDetails() {

        this.skeletonLoading = true;
        try {
            const result = await depositLogService.getDefaultPaymentProvider(
                this.currentStoreId
            );
            this.currentStoreName = result.storeName;
            this.paymentUrl = Utils.WEB_BASE_URL;
            if (result.paymentProvider == "Clover") {

                if (result.isCloverConfigured) {
                    this.paymentUrl += '/serverpay/clover';
                    this.title = "Clover Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'Clover Payment not configured, please contact admin';

                }
            } else if (result.paymentProvider == "Cenpos") {

                if (result.isCenposConfigured) {
                    this.paymentUrl += '/serverpay/cenpos';
                    this.title = "Cenpos Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'Cenpos Payment not configured, please contact admin';

                }

            } else if (result.paymentProvider == "Square") {

                if (result.isSquareConfigured) {
                    this.paymentUrl += '/serverpay/square';
                    this.title = "Square Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'Square Payment not configured, please contact admin';

                }

            } else if (result.paymentProvider == "Payroc") {

                if (result.isPayrocConfigured) {
                    this.paymentUrl += '/serverpay/payroc';
                    this.title = "Payroc Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'Payroc Payment not configured, please contact admin';
                }
            }
            else if (result.paymentProvider == "AuthorizeNet") {
                if (result.isAuthorizeNetConfigured) {
                    this.paymentUrl += '/serverpay/authorizeNet';
                    this.title = "AuthorizeNet Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'AuthorizeNet Payment not configured, please contact admin';
                }
            }
            else if (result.paymentProvider == "Redrock") {
                if (result.isRedrockConfigured) {
                    this.paymentUrl += '/serverpay/redrock';
                    this.title = "Redrock Web Pay";
                    this.isPaymentProviderConfigured = true;
                }
                else {
                    this.paymentProviderStatusMessage = 'Redrock Payment not configured, please contact admin';
                }
            }

        } finally {
            this.validatePaymentProviderDetails();
        }
    }

    public validatePaymentProviderDetails() {
        if (!this.isPaymentProviderConfigured) {
            if (this.paymentProviderStatusMessage) this.showAlert(false, this.paymentProviderStatusMessage);
            this.$emit('paymentDialog', false);
        } else {
            var properties = Object.keys(this.options);
            //Assigning unique id to the form feilds
            properties.forEach((property) => {
                if (property != 'id') {
                    this[property] = this.options.id + this.options[property];
                }
            });
            this.urlFeildId = this.options.id + this.options.url;
        }
        this.skeletonLoading = false;

    }

    public startLoading() {
        this.loading = true;
    }
    public close() {
        this.$emit('paymentDialog', false);
    }
    public created() {
        this.currentStoreId = this.userSession.storeId;
        this.currentEnterpriseId = this.userSession.enterpriseId;
        this.currentTenantId = this.userSession.tenantId;
        this.loggedInUserEmail = this.userSession.email;
        this.loggedInUserId = this.userSession.sessionUserId;
    }
}
